__webpack_require__.p = "https://bmidxbgroupplprod.netlify.app/";